import { render } from "./sem.vue?vue&type=template&id=dc6f334e"
import script from "./sem.vue?vue&type=script&lang=js"
export * from "./sem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__